import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import { downloadAllCredentials } from 'redux/ducks/Credentials';
import { get } from 'lodash';
import classNames from 'classnames';
import { SHOW_TOOLTIP_COLUMNS, createOverflowChecker } from 'helpers/dashboard';
import CredentialsIssueModal from '../CredentialsIssueModal/CredentialsIssueModal';
import moment from 'moment-timezone';
import { withRouter } from 'react-router-dom';
import TrackingService from 'services/TrackingService';
import {
  ATHeader,
  ReliabilityBlock,
  RecentActivityBlock,
  ExperienceSidebar,
  CredentialsBlock,
} from './components';
import { getAthleticTrainerStatistics } from 'redux/ducks/User';

const DEFAULT_STATISTICS = {
  organizationsWorkedWith: 0,
  jobCount: 0,
  calloutUnder1Day: 0,
  callout1To3Days: 0,
  callout3To7Days: 0,
  noShowCount: 0,
  withYou: {
    jobs: 0,
    callouts: 0,
    noShows: 0,
  },
  experience: {
    sports: [],
    settings: [],
  },
};

class ExperienceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isOverflowing: {},
      message: 'N/A',
      issueModalOpen: false,
      showEmail: false,
      showPhone: false,
    };
    this.columnRefs = {};
    SHOW_TOOLTIP_COLUMNS.experienceModal.forEach(column => {
      this.columnRefs[column] = React.createRef();
    });
  }

  toggleIssueModal = () => {
    this.setState({ ...this.state, issueModalOpen: !this.state.issueModalOpen });
  };

  componentDidMount() {
    const checkOverflow = createOverflowChecker('experienceModal', this.columnRefs, this.setState.bind(this));
    this.resizeObserver = new ResizeObserver(checkOverflow);
    SHOW_TOOLTIP_COLUMNS.experienceModal.forEach(column => {
      this.resizeObserver.observe(this.columnRefs[column].current);
    });

    const params = new URLSearchParams(this.props.location.search);
    const jobId = params.get('job');
    if (this.props.job.id.toString() === jobId) this.toggle();
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
  }

  onOpened = () => {
    this.props.getAthleticTrainerStatistics(this.props.id);
  };

  toggle = () => {
    const willOpen = !this.state.open;
    this.setState({ open: willOpen });

    if (willOpen) {
      this.props.onClick();
    } else {
      const params = new URLSearchParams(this.props.location.search);
      if (params.get('job')) {
        params.delete('job');
        this.props.history.replace({
          search: params.toString(),
        });
      }
    }
  };

  onDownloadAllCredentials = () => {
    this.props.downloadAllCredentials(this.props.id);
  };

  getAT = () => {
    const { pendingApplicants, id } = this.props;
    const AT = pendingApplicants.find(at => at.id === id);
    return AT;
  };

  showActions = () => {
    const { job, tz } = this.props;
    if (moment.tz(moment(), tz).isAfter(moment.tz(moment(job.endTime), tz))) return false;

    return this.props.from === 'applicants' || this.props.canDoAction;
  };

  showContactInformation = () => {
    const { job, tz } = this.props;
    if (!job) return false;

    return (
      ['confirmed', 'checked_in'].includes(job.currentState) &&
      moment.tz(moment(), tz).isBefore(moment.tz(moment(job.endTime), tz))
    );
  };

  trackEvent = eventName => {
    const at = this.getAT();
    const eventData = {
      at_id: at.id,
      jp_id: this.props.jobPoster?.id,
      job_id: this.props.job?.id,
    };
    const trackingService = new TrackingService(this.props.session);
    trackingService.track({
      event_name: eventName
        .replace(/^JP/, 'JP_')
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .toLowerCase(),
      event_data: eventData,
    });
    trackingService.trackMixpanel({
      event_name: eventName,
      event_data: eventData,
    });
  };

  onClickShowContact = type => {
    switch (type) {
      case 'phone':
        this.setState({ showPhone: true });
        this.trackEvent('JPPhoneNoClick');
        break;
      case 'email':
        this.setState({ showEmail: true });
        this.trackEvent('JPEmailClick');
        break;
      default:
        break;
    }
  };

  onApprove = () => {
    this.toggle();
    this.props.onApprove();
  };

  onDecline = () => {
    this.toggle();
    this.props.onDecline();
  };

  render() {
    const { id, reviewId, job, tz, eventTitle } = this.props;
    const at = this.getAT();
    const profile = get(at, 'profile', {});

    if (at?.id !== id)
      return (
        <div className="experienceModal">
          <div
            className={classNames('plain-button', {
              'feedback-button': this.props.from === 'reviews',
              'modal-button': this.props.from !== 'reviews',
              'upcoming-button': this.props.from === 'upcoming',
            })}
            onClick={this.toggle}
            id={`atName-${reviewId}`}
            ref={this.columnRefs['atName']}
          >
            {this.props.children}
            {this.state.isOverflowing.atName && this.props.from === 'reviews' && (
              <UncontrolledTooltip target={`atName-${reviewId}`}>{this.props.children}</UncontrolledTooltip>
            )}
          </div>
        </div>
      );

    const credentials = get(at, 'credentials', {});
    const atStatistics = this.props.pendingApplicantsStatistics[id] || DEFAULT_STATISTICS;
    const showJpStats = atStatistics.jobCount > 0;

    return (
      <div className="experienceModal">
        <div
          className={classNames('plain-button', {
            'feedback-button': this.props.from === 'reviews',
            'modal-button': this.props.from !== 'reviews',
            'upcoming-button': this.props.from === 'upcoming',
          })}
          onClick={this.toggle}
          id={`atName-${reviewId}`}
          ref={this.columnRefs['atName']}
        >
          {this.props.children}
          {this.state.isOverflowing.atName && this.props.from === 'reviews' && (
            <UncontrolledTooltip target={`atName-${reviewId}`}>{this.props.children}</UncontrolledTooltip>
          )}
        </div>
        <Modal
          isOpen={this.state.open}
          onOpened={this.onOpened}
          toggle={this.toggle}
          className="experience-modal-content"
          contentClassName="experience-modal-content__inner"
        >
          <ModalHeader className="header" toggle={this.toggle}>
            <ATHeader at={at} job={job} tz={tz} eventTitle={eventTitle} />
          </ModalHeader>
          <ModalBody>
            <div className="experience-modal-grid">
              <div className="experience-modal-grid__left">
                <ReliabilityBlock
                  showJpStats={showJpStats}
                  statistics={atStatistics}
                  showContactInfo={this.showContactInformation()}
                  at={at}
                  onClickShowContact={this.onClickShowContact}
                  showEmail={this.state.showEmail}
                  showPhone={this.state.showPhone}
                />
                <RecentActivityBlock statistics={atStatistics} />
              </div>
              <div className="experience-modal-grid__right">
                <ExperienceSidebar profile={profile} statistics={atStatistics} at={at} />
                <CredentialsBlock
                  at={at}
                  credentials={credentials}
                  usStates={this.props.usStates}
                  jobState={this.props.jobState}
                  onDownloadAll={this.onDownloadAllCredentials}
                  onReportIssue={this.toggleIssueModal}
                />
              </div>
            </div>
          </ModalBody>
          {this.showActions() && (
            <ModalFooter className="actions">
              <button className="btn decline-button" onClick={this.onDecline}>
                DECLINE
              </button>
              <button
                className={classNames('btn accept-button', {
                  acceptDisabled: this.props.acceptDisabled,
                })}
                disabled={this.props.acceptDisabled}
                onClick={this.onApprove}
              >
                ACCEPT
              </button>
            </ModalFooter>
          )}
        </Modal>
        <CredentialsIssueModal
          isOpen={this.state.issueModalOpen}
          toggle={this.toggleIssueModal}
          job={this.props.job}
          at={at}
          eo={this.props.session.currentUser}
          session={this.props.session}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    usStates: state.enums.usStates,
    companyName: state.session.currentUser.companyName,
    jobPoster: state.session.currentUser,
    session: state.session,
    pendingApplicantsStatistics: state.user.pendingApplicantsStatistics,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    downloadAllCredentials: ATId => dispatch(downloadAllCredentials(ATId)),
    getAthleticTrainerStatistics: ATId => dispatch(getAthleticTrainerStatistics(ATId)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExperienceModal));
